<script lang="ts">
  import type { ConnectionPath, Waypoint } from "../../support/connections";
  import { fade } from "svelte/transition";
  import MapEvent from "./map-event.svelte";
  import { linePath } from "../../support/svg";
  import { getActiveWaypoints } from "../../domain/map";
  import { constrain } from "../../support/geometry";
  import type { Maybe } from "../../types";

  export let width: number, height: number, zoom: number;
  export let activePlaceId = null;
  export let activeWaypointId = null;
  export let showActiveWaypoint = false;
  export let route: Maybe<ConnectionPath> = null;
  export let waypoints: Waypoint[] = [];

  $: scale = constrain(1 / zoom, 0.7, 2);
  $: pins = getActiveWaypoints(waypoints, activePlaceId, activeWaypointId);

  $: shownWaypoint = showActiveWaypoint ? waypoints.find((w) => w.id == activeWaypointId) : null;
</script>

<svg class="Container" {width} {height} viewBox="0 0 {width} {height}">
  <g transition:fade>
    {#if route}
      <path d={linePath(route.path)} style="--scale: {scale}" />
    {/if}

    {#each pins as waypoint}
      <MapEvent {waypoint} {zoom} />
    {:else}
      {#if shownWaypoint}
        <MapEvent waypoint={shownWaypoint} {zoom} />
      {/if}
    {/each}
  </g>
</svg>

<style>
  @keyframes crawl {
    0% {
      stroke-dashoffset: 0;
    }

    100% {
      stroke-dashoffset: calc(var(--dash-length) + var(--dash-gap));
    }
  }

  g {
    will-change: transform;
  }

  path {
    --dash-length: calc(2px * var(--scale));
    --dash-gap: calc(10px * var(--scale));
    animation: 1200ms crawl infinite linear;
    stroke: var(--connection-color, #ffff00);
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: calc(4px * var(--scale));
    stroke-dasharray: var(--dash-length) var(--dash-gap);
  }

  .Container {
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
    pointer-events: none;
  }
</style>
